import React, { FC } from "react";
import { useLocation, useRoutes } from "react-router";
import { Breadcrumb } from "antd";
import { ConfigurationMenu } from "./configuration-menu";
import {
  findConfigurationMenuItem,
  firstPartOfPath,
} from "../../containers/configuration/configuration-menu-item";
import pageStyles from "../page.module.css";
import styles from "./configuration.module.css";
import { Permission } from "../../hooks";
import { AccessControl } from "../../components/auth";
import { Link } from "react-router-dom";
import { ConfigurationMenuItems } from "../../containers/configuration/configuration-menu-items";

const { ["page-content-zero-padding"]: pageContentClassName } = pageStyles as any;
const {
  ["menu-container"]: menuContainerClassName,
  ["content-container"]: contentContainerClassName,
} = styles as any;

export const Configuration: FC = () => {
  const { pathname } = useLocation();
  const currentPage = firstPartOfPath(pathname);
  const CONFIGURATION_MENU_ITEMS = ConfigurationMenuItems();
  const routes = useRoutes(CONFIGURATION_MENU_ITEMS);
  const selectedMenuItem = findConfigurationMenuItem(pathname, CONFIGURATION_MENU_ITEMS);
  const { root, levelOne, levelTwo } = selectedMenuItem;

  return (
    <div className={pageContentClassName}>
      <AccessControl
        permissions={[
          Permission.READ_CONFIG,
          Permission.UPDATE_CONFIG,
          Permission.MATTER_TEMPLATE_EDITOR,
        ]}
      >
        <div className={menuContainerClassName}>
          <ConfigurationMenu
            items={CONFIGURATION_MENU_ITEMS}
            selectedMenuItem={selectedMenuItem}
            adminPageRoot={currentPage}
          />
        </div>
        <div className={contentContainerClassName}>
          <div>
            {root && (
              <>
                <Breadcrumb separator={<h3>&gt;</h3>}>
                  <Breadcrumb.Item>
                    <h3>{root!.title}</h3>
                  </Breadcrumb.Item>
                  {levelOne && (
                    <Breadcrumb.Item>
                      {levelTwo ? (
                        <Link to={`${root!.path}/${levelOne!.path}`}>
                          <h3>{levelOne!.title}</h3>
                        </Link>
                      ) : (
                        <h3>{levelOne!.title}</h3>
                      )}
                    </Breadcrumb.Item>
                  )}
                  {levelTwo && (
                    <Breadcrumb.Item>
                      <h3>{levelTwo!.title}</h3>
                    </Breadcrumb.Item>
                  )}
                </Breadcrumb>
              </>
            )}
          </div>
          <div>{routes}</div>
        </div>
      </AccessControl>
    </div>
  );
};
